module.exports = __webpack_public_path__ + "img/ic_talk.5bdd91a8.svg";